import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import { APPOINTMENT_DETAILS_TYPES } from '../../healthboard/appointment-details';
import { consts as EDIT_PAYMENT_CONST } from '../../healthboard/requests/edit-payment-req';

export const consts = createReqConsts('dashboard', 'appointment-details-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dashboard',
  type: 'get',
  slug: [
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentId'],
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
  appointment: {},
  appointmentId: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.SEND: {
      return {
        ...state,
        sending: true,
        appointmentId: payload.appointmentId,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        sending: false,
        appointment: payload,
        appointmentId: null,
      };
    }

    case EDIT_PAYMENT_CONST.SUCCEED: {
      const target =
        state.appointment.id === action.payload.id ? state.appointment : null;
      if (target) target.copay = action.payload.copay;
      return {
        ...state,
        appointment: {
          ...state.appointment,
        },
      };
    }

    case APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT:
    case consts.CLEAR: {
      return {
        ...state,
        appointment: {},
        appointmentId: null,
      };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/appointment-details-req.js